import React, { useState, useEffect, useContext } from 'react'
import { GlobalContext } from 'react-pagebuilder/services/globalContext'
import { CKEditor } from 'ckeditor4-react'
import { AddGblinkPlugin } from './ckeditor/gblink/plugin'
import { AddGbFileLinkPlugin } from './ckeditor/gbfilelink/plugin'

export const RichTextEditor = ({ name, value, setValue, noHtml, readOnly = false }) => {
  //const editorName = noHtml ? 'ckeditor-no-toolbar' : 'ckeditor' + '_' + name
  const editorName = 'ckeditor' + '_' + name
  const { lang } = useContext(GlobalContext)

  const toggleToolbarVisibility = (value) => {
    const toolbarElement = document.getElementsByClassName('cke_editor_ckeditor_' + name)[0]
    if (toolbarElement) {
      if (value) {
        toolbarElement.classList.remove('ckeditor-hide')
        toolbarElement.classList.add('ckeditor-show')
      } else {
        toolbarElement.classList.add('ckeditor-hide')
        toolbarElement.classList.remove('ckeditor-show')
      }
    }
  }

  useEffect(() => {
    toggleToolbarVisibility(!readOnly)
  }, [readOnly])

  return (
    <CKEditor
      name={editorName}
      initData={value}
      type={'inline'}
      onChange={({ editor }) => {
        setValue(editor.getData())
      }}
      readOnly={readOnly}
      config={{
        extraPlugins: [
          'justify',
          'link',
          'tab',
          'copyformatting',
          'font',
          'sourcedialog',
          'image',
          'gblink',
          'gbfilelink',
        ],
        removePlugins: ['magicline', 'sourcearea'],
        toolbar: noHtml ? NO_HTML_TOOLBAR : TOOLBAR,
        removeButtons: '',
        removeDialogTabs: '',
        versionCheck: false,
        tabSpaces: 4,
        stylesSet: PAGEBUILDER_TEXT_STYLES,
        extraAllowedContent: 'a[data-gb-href,data-gb-fileid]',
      }}
      onInstanceReady={({ editor }) => {
        toggleToolbarVisibility(!readOnly)
      }}
      onBeforeLoad={(CKEDITOR) => {
        AddGblinkPlugin(CKEDITOR, lang)
        AddGbFileLinkPlugin(CKEDITOR, lang)
      }}
    />
  )
}

const NO_HTML_TOOLBAR = [{ name: 'clipboard', items: ['Undo', 'Redo'] }]

const TOOLBAR = [
  { name: 'clipboard', items: ['Undo', 'Redo'] },
  { name: 'source', items: ['Source'] },
  {
    name: 'paragraph',
    items: [
      'BulletedList',
      'NumberedList',
      '-',
      'JustifyLeft',
      'JustifyCenter',
      'JustifyRight',
      'JustifyBlock',
    ],
  },
  {
    name: 'basicstyles',
    items: [
      'Bold',
      'Italic',
      'Underline',
      'Strike',
      'Subscript',
      'Superscript',
      '-',
      'CopyFormatting',
      'RemoveFormat',
    ],
  },
  { name: 'links', items: ['Gblink', 'Gbfilelink', 'Link', 'Unlink' /* 'Anchor' */] },
  { name: 'styles', items: ['Styles'] },
  { name: 'document', items: ['Sourcedialog'] },
  { name: 'other', items: ['Table', 'SpecialChar' /* 'FilerImage', 'Image' */] },
]

const PAGEBUILDER_TEXT_STYLES = [
  { name: 'Normale', element: 'p' },
  { name: 'Titolo 2', element: 'h2', attributes: { class: 'heading2' } },
  { name: 'Titolo 3', element: 'h3', attributes: { class: 'heading3' } },
  { name: 'Titolo 4', element: 'h4', attributes: { class: 'heading4' } },
]
